import TagInput from "components/TagInput"
import { useFormik } from "formik"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import * as Yup from "yup"
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  Input,
  Label,
  Row,
} from "reactstrap"
import { updatePvsRegistration } from "../../../redux/actions/pvs"
import { UPDATE_PVS_REGISTRATION_RESET } from "../../../redux/types/pvs"
import { useNavigate } from "react-router-dom"
import ErrorPopup from "components/ErrorPopup"
import Select from "react-select"

const stateOptions = [
  {
    options: [
      {
        label: "Andaman and Nicobar Islands",
        value: 4023,
      },
      {
        label: "Andhra Pradesh",
        value: 4017,
      },
      {
        label: "Arunachal Pradesh",
        value: 4024,
      },
      {
        label: "Assam",
        value: 4027,
      },
      {
        label: "Bihar",
        value: 4037,
      },
      {
        label: "Chandigarh",
        value: 4031,
      },
      {
        label: "Chhattisgarh",
        value: 4040,
      },
      {
        label: "Dadra and Nagar Haveli and Daman and Diu",
        value: 4033,
      },
      {
        label: "Delhi",
        value: 4021,
      },
      {
        label: "Goa",
        value: 4009,
      },
      {
        label: "Gujarat",
        value: 4030,
      },
      {
        label: "Haryana",
        value: 4007,
      },
      {
        label: "Himachal Pradesh",
        value: 4020,
      },
      {
        label: "Jammu and Kashmir",
        value: 4029,
      },
      {
        label: "Jharkhand",
        value: 4025,
      },
      {
        label: "Karnataka",
        value: 4026,
      },
      {
        label: "Kerala",
        value: 4028,
      },
      {
        label: "Ladakh",
        value: 4852,
      },
      {
        label: "Lakshadweep",
        value: 4019,
      },
      {
        label: "Madhya Pradesh",
        value: 4039,
      },
      {
        label: "Maharashtra",
        value: 4008,
      },
      {
        label: "Manipur",
        value: 4010,
      },
      {
        label: "Meghalaya",
        value: 4006,
      },
      {
        label: "Mizoram",
        value: 4036,
      },
      {
        label: "Nagaland",
        value: 4018,
      },
      {
        label: "Odisha",
        value: 4013,
      },
      {
        label: "Puducherry",
        value: 4011,
      },
      {
        label: "Punjab",
        value: 4015,
      },
      {
        label: "Rajasthan",
        value: 4014,
      },
      {
        label: "Sikkim",
        value: 4034,
      },
      {
        label: "Tamil Nadu",
        value: 4035,
      },
      {
        label: "Telangana",
        value: 4012,
      },
      {
        label: "Tripura",
        value: 4038,
      },
      {
        label: "Uttar Pradesh",
        value: 4022,
      },
      {
        label: "Uttarakhand",
        value: 4016,
      },
      {
        label: "West Bengal",
        value: 4853,
      },
    ],
  },
]

const Step5 = props => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isErrorOpen, setIsErrorOpen] = useState(false)
  const [isErrorMessage, setIsErrorMessage] = useState("")

  const user = useSelector(state => state.auth.user)
  const pvsFormData = useSelector(state => state.pvs.pvsFormData)
  const updatePvsRegistrationScreen = useSelector(
    state => state.screens.pvs.updatePvsRegistration
  )
  useEffect(() => {
    if (updatePvsRegistrationScreen.success && props.activeTab === 5) {
      // toast.success(updatePvsRegistrationScreen.message)
      dispatch({ type: UPDATE_PVS_REGISTRATION_RESET })
      navigate("/confirm-registration")
    }
    if (updatePvsRegistrationScreen.error && props.activeTab === 5) {
      toast.error(updatePvsRegistrationScreen.error)
      dispatch({ type: UPDATE_PVS_REGISTRATION_RESET })
    }
  }, [updatePvsRegistrationScreen])

  useEffect(() => {
    formik.setValues({
      firstName: user ? user.first_name : "",
      lastName: user ? user.last_name : "",
      companyName: user ? user.company_name : "",
      address: "",
      city: user && user.city ? user.city : "Pune",
      state: user && user.state
        ? stateOptions[0].options.find(value => value.label === user.state)
        : stateOptions[0].options[20],
      pincode: "",
      email: user ? user.email_id : "",
      mobileNo: user ? user.mobile_no : "",
    })
  }, [])

  useEffect(() => {
    if (pvsFormData && pvsFormData.billing_details) {
      formik.setValues({
        firstName: pvsFormData.billing_details.first_name,
        lastName: pvsFormData.billing_details.last_name,
        companyName: pvsFormData.billing_details.company_name,
        address: pvsFormData.billing_details.address,
        city: pvsFormData.billing_details.city || "Pune",
        state:
          stateOptions[0].options.find(
            value => value.label === pvsFormData.billing_details.state
          ) || stateOptions[0].options[20],
        pincode: pvsFormData.billing_details.pincode,
        email: pvsFormData.billing_details.email_id,
        mobileNo: pvsFormData.billing_details.mobile_no,
        gstNumber: pvsFormData.billing_details.gst_number,
      })
    }
  }, [pvsFormData])

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      companyName: "",
      address: "",
      city: "Pune",
      state: stateOptions[0].options[20],
      pincode: "",
      email: "",
      mobileNo: "",
      gstNumber: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First Name is Required"),
      lastName: Yup.string().required("Last Name is Required"),
      companyName: Yup.string().required("Company Name is Required"),
      address: Yup.string().required("Address is Required"),
      city: Yup.string().required("City is Required"),
      state: Yup.object().required("State is Required"),
      pincode: Yup.string().required("Pincode is Required"),
      email: Yup.string().email("Invalid email").required("Email is Required"),
      mobileNo: Yup.string()
        .matches(/^[6-9]\d{9}$/, "Invalid Mobile Number")
        .required("Mobile Number Required"),
    }),
    onSubmit: values => {
      let requestData = {
        step: 5,
        pvs_entry_id: pvsFormData.pvs_entry_id,
        data: {
          first_name: values.firstName,
          last_name: values.lastName,
          email_id: values.email,
          mobile_no: values.mobileNo,
          gst_number: values.gstNumber,
          company_name: values.companyName,
          address: values.address,
          city: values.city,
          state: values.state.label,
          pincode: values.pincode,
          region: "",
        },
      }
      dispatch(updatePvsRegistration(requestData))
    },
  })

  useEffect(() => {
    if (formik.isSubmitting && formik.errors) {
      formik.setSubmitting(false)
      if (Object.keys(formik.errors).length > 0) {
        let message = (
          <div>
            <ul className="mb-0 ps-3">
              {Object.keys(formik.errors).map(key => (
                <li key={key} className="mb-3">
                  {formik.errors[key]}
                </li>
              ))}
            </ul>
          </div>
        )
        setIsErrorMessage(message)
        setIsErrorOpen(true)
      }
    }
  }, [formik])

  return (
    <div className="d-flex flex-column gap-4">
      <Form onSubmit={formik.handleSubmit}>
        <Card className="border-0 shadow-sm">
          <CardBody>
            <h4 className="mb-3">Billing Details</h4>
            <div className="mb-3 row">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="txtFirstName">
                  Primary Contact <span className="text-danger">*</span>
                </Label>
              </div>
              <div className="col-12 col-sm">
                <div className="row g-3">
                  <div className="col-sm-6">
                    <Input
                      id="txtFirstName"
                      name="firstName"
                      rows="4"
                      className="form-control"
                      placeholder="First Name"
                      value={formik.values.firstName}
                      onChange={formik.handleChange}
                    ></Input>

                    {formik.touched.firstName && formik.errors.firstName && (
                      <div className="text-danger small mt-1">
                        {formik.errors.firstName}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <Input
                      id="txtLastName"
                      name="lastName"
                      rows="4"
                      className="form-control"
                      placeholder="Last Name"
                      value={formik.values.lastName}
                      onChange={formik.handleChange}
                    />

                    {formik.touched.lastName && formik.errors.lastName && (
                      <div className="text-danger small mt-1">
                        {formik.errors.lastName}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-3 row">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="txtCompanyName">
                  Company Name <span className="text-danger">*</span>
                </Label>
              </div>
              <div className="col-12 col-sm-9">
                <Input
                  id="txtCompanyName"
                  name="companyName"
                  rows="4"
                  className="form-control"
                  placeholder="Company Name"
                  value={formik.values.companyName}
                  onChange={formik.handleChange}
                />

                {formik.touched.companyName && formik.errors.companyName && (
                  <div className="text-danger small mt-1">
                    {formik.errors.companyName}
                  </div>
                )}
              </div>
            </div>

            <div className="mb-3 row">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="txtAddress">
                  Address <span className="text-danger">*</span>
                </Label>
              </div>
              <div className="col-12 col-sm-9">
                <Input
                  id="txtAddress"
                  name="address"
                  type="textarea"
                  className="form-control"
                  value={formik.values.address}
                  onChange={formik.handleChange}
                />

                {formik.touched.address && formik.errors.address && (
                  <div className="text-danger small mt-1">
                    {formik.errors.address}
                  </div>
                )}
              </div>
            </div>

            <div className="mb-3 row">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="ddlState">
                  State <span className="text-danger">*</span>
                </Label>
              </div>
              <div className="col-12 col-sm-5">
                <Select
                  id="state"
                  name="state"
                  options={stateOptions}
                  value={formik.values.state}
                  onChange={val => {
                    formik.setFieldValue("state", val)
                  }}
                  classNamePrefix="select2-selection"
                  className="customselect"
                />

                {formik.touched.state && formik.errors.state && (
                  <div className="text-danger small mt-1">
                    {formik.errors.state}
                  </div>
                )}
              </div>
            </div>

            <div className="mb-3 row">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="txtCity">
                  City <span className="text-danger">*</span>
                </Label>
              </div>
              <div className="col-12 col-sm-5">
                <Input
                  id="txtCity"
                  name="city"
                  rows="4"
                  className="form-control"
                  placeholder="City"
                  value={formik.values.city}
                  onChange={formik.handleChange}
                />

                {formik.touched.city && formik.errors.city && (
                  <div className="text-danger small mt-1">
                    {formik.errors.city}
                  </div>
                )}
              </div>
            </div>

            <div className="mb-3 row">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="txtPincode">
                  Pin Code <span className="text-danger">*</span>
                </Label>
              </div>
              <div className="col-12 col-sm-5">
                <Input
                  id="txtPincode"
                  name="pincode"
                  type="number"
                  className="form-control"
                  placeholder="Pincode"
                  value={formik.values.pincode}
                  onChange={formik.handleChange}
                />

                {formik.touched.pincode && formik.errors.pincode && (
                  <div className="text-danger small mt-1">
                    {formik.errors.pincode}
                  </div>
                )}
              </div>
            </div>

            <div className="mb-3 row">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="txtGst">
                  GST Number
                </Label>
              </div>
              <div className="col-12 col-sm-5">
                <Input
                  id="txtGst"
                  name="gstNumber"
                  rows="4"
                  className="form-control"
                  placeholder="GST Number"
                  value={formik.values.gstNumber}
                  onChange={formik.handleChange}
                />

                {formik.touched.gstNumber && formik.errors.gstNumber && (
                  <div className="text-danger small mt-1">
                    {formik.errors.gstNumber}
                  </div>
                )}
              </div>
            </div>

            <div className="mb-3 row">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="txtEmail">
                  Email ID <span className="text-danger">*</span>
                </Label>
              </div>
              <div className="col-12 col-sm-5">
                <Input
                  id="txtEmail"
                  name="email"
                  type="email"
                  className="form-control"
                  placeholder="name@email.com"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                />

                {formik.touched.email && formik.errors.email && (
                  <div className="text-danger small mt-1">
                    {formik.errors.email}
                  </div>
                )}
              </div>
            </div>

            <div className="mb-3 row">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="txtMobile">
                  Mobile Number <span className="text-danger">*</span>
                </Label>
              </div>
              <div className="col-12 col-sm-5">
                <Input
                  id="txtMobile"
                  name="mobileNo"
                  rows="4"
                  className="form-control"
                  placeholder="Enter your name"
                  type="text"
                  value={formik.values.mobileNo}
                  onChange={formik.handleChange}
                />

                {formik.touched.mobileNo && formik.errors.mobileNo && (
                  <div className="text-danger small mt-1">
                    {formik.errors.mobileNo}
                  </div>
                )}
              </div>
            </div>
          </CardBody>
        </Card>

        <div className="pvs-reg-actions actions">
          <div className="btngroup-pvs">
            <div>
              <Button
                color="primary"
                size="md"
                disabled={props.activeTab === 1}
                onClick={() => {
                  props.toggleTab(props.activeTab - 1)
                }}
              >
                <i className="dripicons-arrow-thin-left"></i>
                <span>Previous</span>
              </Button>
            </div>
            <div>
              <Button color="primary" size="md" type="submit">
                <span>Save & Continue</span>
                <i className="dripicons-arrow-thin-right"></i>
              </Button>
            </div>
          </div>
        </div>
      </Form>
      <ErrorPopup
        isOpen={isErrorOpen}
        toggle={() => setIsErrorOpen(!isErrorOpen)}
        title="Fix following errors"
        message={isErrorMessage}
      />
    </div>
  )
}

export default Step5
